import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { VerticalScrollIndicator } from '@/components/ui/VerticalScrollIndicator';

export const Layout = () => {
  return (
    <div
      className="flex min-h-screen flex-col"
      style={{ backgroundColor: 'var(--bg-page)' }}
    >
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <VerticalScrollIndicator />
    </div>
  );
};
